import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import "./Profile.css";
import "../App.css";
import { MainContext } from "../contexts/MainContext";
import HashLoader from "react-spinners/HashLoader";
import { fetchRetry } from "../functions/request";
import SubTitle from "../components/SubTitle";
import Input from "../components/Input";
import SecButton from "../components/SecButton";
import {
  objectToArray,
  reformatDate,
  reformatDateReverse,
} from "../functions/utils";
import Title from "../components/Title";
import ErrorMessage from "../components/ErrorMessage";
import qs from "qs";
import TextInputModal from "../components/modals/TextInputModal";
import { PermittedAccount, RowData } from "../Types";
import Table from "../components/Table/Table";
import Status from "../components/Status/Status";
import MainBtn from "../components/MainBtn";
import CreateFamilyMember from "../components/modals/CreateFamilyMember";
import InfoContainer from "../components/InfoContainer";

type Props = {};
type ComposedProps = Props & RouteComponentProps<{}>;

export default class Profile extends React.Component<
  ComposedProps,
  {
    userLoaded: boolean;
    userData: {
      fName?: string;
      lName?: string;
      birthDate?: Date;
      address?: {
        street?: string;
        houseNumber?: string;
        zipcode?: string;
        city?: string;
      };
      phoneNumber?: string;
    };
    updateLoading: boolean;
    fName: string;
    lName: string;
    phoneNumber: string;
    street: string;
    houseNumber: string;
    zipcode: string;
    city: string;
    birthDate: string;
    change: boolean;
    errorMessage: string | null;
    redirect: string | null;
    completeTitle: boolean;
    showRequestTransfer: boolean;
    transferErrMsg: string | null;
    transferLoading: boolean;
    permittedAccountsTable: RowData[];
    showCreateFamilyMember: boolean;
  }
> {
  static contextType = MainContext;
  constructor(props: ComposedProps) {
    super(props);
    this.state = {
      userLoaded: false,
      userData: {},
      fName: "",
      lName: "",
      updateLoading: false,
      phoneNumber: "",
      street: "",
      houseNumber: "",
      zipcode: "",
      city: "",
      birthDate: "",
      change: false,
      errorMessage: null,
      redirect: null,
      completeTitle:
        qs.parse(this.props.location.search, {
          ignoreQueryPrefix: true,
        }).complete === "true",
      showRequestTransfer: false,
      transferErrMsg: null,
      transferLoading: false,
      permittedAccountsTable: [],
      showCreateFamilyMember: false,
    };
  }

  componentDidMount = () => {
    this.requestUser();
    // this.requestOwnUser();
  };

  requestOwnUser = () => {
    fetchRetry("getUserFromId", { targetUserId: this.context.user.uid }, 1, 5)
      .then(this.handleOwnUserData)
      .catch(this.handleError);
  };
  handleOwnUserData = ({ data }: any) => {
    if (data.success) {
      const userData = data.data;
      const permittedAccountsTable = objectToArray(
        userData.permittedAccounts
      ).map((account: PermittedAccount) => {
        return {
          cells: [
            { value: account.fName, sort: account.fName },
            { value: account.lName, sort: account.lName },
            { value: account.email, sort: account.email },
            {
              value: <Status type={account.status} />,
              sort: account.status,
            },
          ],
          onClick: ``,
        };
      });
      this.setState({ permittedAccountsTable });
    }
  };

  requestUser = () => {
    fetchRetry(
      "getUserFromId",
      { targetUserId: this.context.selectedUserId },
      1,
      5
    )
      .then(this.handleUserData)
      .catch(this.handleError);
  };

  requestTransfer = (email: string) => {
    this.setState({ transferLoading: true });
    fetchRetry(
      "requestAccountTransfer",
      { email, clubId: this.context.clubId },
      1,
      5
    )
      .then(this.handleRequestTransfer)
      .catch(this.handleError);
  };

  handleRequestTransfer = ({ data }: any) => {
    this.setState({ transferLoading: false });
    if (data.success) {
      this.setState({ showRequestTransfer: false, transferErrMsg: null });
      this.context.requestOwnUserData();
    } else {
      this.setState({ transferErrMsg: data.errorMsgDe });
    }
  };

  handleUserData = ({ data }: any) => {
    if (data.success) {
      const userData = data.data;
      this.setState(
        {
          userData: userData,
          fName: userData.fName ? userData.fName : "",
          lName: userData.lName ? userData.lName : "",
          street: userData.address?.street ? userData.address.street : "",
          houseNumber: userData.address?.houseNumber
            ? userData.address.houseNumber
            : "",
          zipcode: userData.address?.zipcode ? userData.address.zipcode : "",
          city: userData.address?.city ? userData.address.city : "",
          phoneNumber: userData.phoneNumber ? userData.phoneNumber : "",
          birthDate: reformatDateReverse(userData.birthDate),
          userLoaded: true,
        },
        this.checkChange
      );
    } else {
      this.setState({ userLoaded: true });
    }
  };

  handleUpdateUserData = () => {
    this.setState({ updateLoading: true });
    fetchRetry(
      "updateUserDataFNew",
      {
        fName: this.state.fName,
        lName: this.state.lName,
        address: {
          city: this.state.city,
          zipcode: this.state.zipcode,
          street: this.state.street,
          houseNumber: this.state.houseNumber,
        },
        phoneNumber: this.state.phoneNumber,
        birthDate: reformatDate(this.state.birthDate),
        targetUserId: this.context.selectedUserId,
      },
      1,
      5
    )
      .then(this.handleSuccessUpdatedUserData)
      .catch(this.handleError);
  };

  handleSuccessUpdatedUserData = ({ data }: any) => {
    this.setState({ updateLoading: false });
    if (data.success) {
      const redirect: any = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      }).redirect;
      if (redirect) {
        this.setState({ redirect });
      }
      this.requestUser();
      this.context.requestOwnUserData();
      this.context.requestUserData();

      this.setState({ errorMessage: null });
    } else {
      this.setState({ errorMessage: data.errorMsgDe });
    }
  };

  handleError = (err: any) => {
    console.error(err);
  };

  handleFNameChange = (val: any) => {
    this.setState({ fName: val }, this.checkChange);
  };

  handleLNameChange = (val: any) => {
    this.setState({ lName: val }, this.checkChange);
  };

  handlePhoneNumberChange = (val: any) => {
    this.setState({ phoneNumber: val }, this.checkChange);
  };

  handleCityChange = (val: any) => {
    this.setState({ city: val }, this.checkChange);
  };

  handleHouseNumberChange = (val: any) => {
    this.setState({ houseNumber: val }, this.checkChange);
  };

  handleZipcodeChange = (val: any) => {
    this.setState({ zipcode: val }, this.checkChange);
  };

  handleStreetChange = (val: any) => {
    this.setState({ street: val }, this.checkChange);
  };

  handleBirthDateChange = (val: any) => {
    this.setState({ birthDate: val.target.value }, this.checkChange);
  };

  checkChange = () => {
    /* eslint eqeqeq: 0 */
    this.setState({
      change: !!(
        this.state.fName != this.state.userData.fName ||
        this.state.lName != this.state.userData.lName ||
        (this.state.street != this.state.userData.address?.street
          ? this.state.userData.address?.street
          : "") ||
        (this.state.houseNumber != this.state.userData.address?.houseNumber
          ? this.state.userData.address?.houseNumber
          : "") ||
        (this.state.zipcode != this.state.userData.address?.zipcode
          ? this.state.userData.address?.zipcode
          : "") ||
        (this.state.city != this.state.userData.address?.city
          ? this.state.userData.address?.city
          : "") ||
        this.state.phoneNumber !=
          (this.state.userData.phoneNumber
            ? this.state.userData.phoneNumber
            : "") ||
        reformatDate(this.state.birthDate) != this.state.userData.birthDate
      ),
    });
  };

  handleHideRequestTransfer = () => {
    this.setState({ showRequestTransfer: false });
  };

  onClickRequestTransfer = () => {
    this.setState({ showRequestTransfer: true });
  };

  handleHideCreateFamilyMember = () => {
    this.setState({ showCreateFamilyMember: false });
  };

  handleCreateFamilyMember = () => {};

  onClickCreateAccount = () => {
    this.setState({ showCreateFamilyMember: true });
  };

  render() {
    if (!this.context.user) {
      return <Redirect to={"/"} />;
    }
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (!this.state.userLoaded) {
      return (
        <>
          <div className="loading-container">
            <HashLoader color={"#c31924"} size={100} loading={true} />
          </div>
        </>
      );
    }
    return (
      <>
        <TextInputModal
          show={this.state.showRequestTransfer}
          handleClose={this.handleHideRequestTransfer}
          handleConfirm={this.requestTransfer}
          loading={this.state.transferLoading}
          btnText="Übernahme anfordern"
          textBoxPlaceholder="E-Mail-Adresse"
          title="Übernahme anfordern"
          description="Wenn du alle Profile deiner Familie über einen Account verwalten möchtest, kannst du hier eine Übernahme an einen bestehenden Account anfordern. Nach der Anforderung, bekommt der Account-Besitzer eine E-Mail mit einem Link, um die Übernahme zu bestätigen."
          errorMsg={this.state.transferErrMsg}
        />
        <CreateFamilyMember
          show={this.state.showCreateFamilyMember}
          handleClose={this.handleHideCreateFamilyMember}
          defaultLName={this.state.lName}
          defaultCity={this.state.city}
          defaultZipcode={this.state.zipcode}
          defaultStreet={this.state.street}
          defaultHouseNumber={this.state.houseNumber}
          defaultPhoneNumber={this.state.phoneNumber}
        />

        <div className="subscreen-main-container">
          <div className="subscreen-box-container">
            <Title
              title={
                this.state.completeTitle
                  ? "Bitte vervollständige zuerst dein Profil"
                  : "Profil"
              }
            />
            <SubTitle title="Name" />
            <div className="course-time-input-container">
              <Input
                value={this.state.fName}
                onChange={this.handleFNameChange}
                placeholder="Vorname"
                disabled={!!this.state.userData.fName}
              />
              <Input
                value={this.state.lName}
                onChange={this.handleLNameChange}
                placeholder="Nachname"
                disabled={!!this.state.userData.lName}
              />
            </div>
            <SubTitle title="Adresse" />
            <div className="course-time-input-container">
              <Input
                value={this.state.street}
                onChange={this.handleStreetChange}
                placeholder="Straße"
                className="street-input"
              />
              <Input
                value={this.state.houseNumber}
                onChange={this.handleHouseNumberChange}
                placeholder="Nr."
                className="house-number-input"
              />
            </div>
            <div className="profile-location-container">
              <Input
                value={this.state.zipcode}
                onChange={this.handleZipcodeChange}
                placeholder="PLZ"
                className="zipcode-input"
              />
              <Input
                value={this.state.city}
                onChange={this.handleCityChange}
                placeholder="Stadt"
                className="city-input"
              />
            </div>
            <SubTitle title="Telefonnummer" />
            <Input
              value={this.state.phoneNumber}
              onChange={this.handlePhoneNumberChange}
              placeholder="Telefonnummer"
            />
            <SubTitle title="Geburtsdatum" />
            <input
              type="date"
              className="input-container"
              value={this.state.birthDate}
              onChange={this.handleBirthDateChange}
              disabled={!!this.state.userData.birthDate}
            />
            <ErrorMessage message={this.state.errorMessage} />
            <div className="modal-btn-container">
              <SecButton
                title="Speichern"
                onClick={this.handleUpdateUserData}
                color="green"
                change={this.state.change}
                loading={this.state.updateLoading}
              />
            </div>
            <Title title="Familienmitglieder" />
            <InfoContainer>
              Diese Funktion ist für Familien gedacht, die ihre Kurse und
              Mitgliedschaften über einen Account verwalten möchte.
            </InfoContainer>
            <div className="familie-account-btn-wrapper">
              <MainBtn onClick={this.onClickRequestTransfer}>
                Bestehenden Account verknüpfen
              </MainBtn>
              <MainBtn onClick={this.onClickCreateAccount}>
                Familienmitglied anlegen
              </MainBtn>
            </div>
            <Table
              header={[
                { title: "Vorname", displayWidth: 450 },
                { title: "Nachname", displayWidth: 700 },
                { title: "E-Mail" },
                { title: "Status" },
              ]}
              data={this.context.permittedAccountsTable}
              loaded={this.state.userLoaded}
              skeletonRows={2}
              onClick={() => {}}
            />
          </div>
        </div>
      </>
    );
  }
}
